// Module
var code = "<button class=\"mobile-exit-search\" ng-click=\"returnToMapCallback()\" name=\"return-to-map\"><i class=\"fa fa-long-arrow-left\"></i> <span translate-once=\"student_network.network_map_filter_box.return_to_map\"></span></button>";
// Exports
export default code;